import { useEffect } from 'react';

/**
 * Sets `document.title` for the page while it is mounted.
 *
 * The production site titles every page `<name> - Tokeness` (and the home page
 * `Tokeness - 一个入口，所有模型 | AI API`); a single SPA title loses which page
 * a tab holds, so each route names itself.
 */
export function usePageTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    // Restore on the way out: without this, navigating from a titled page to an
    // untitled one leaves the stale page name on the tab.
    return () => {
      document.title = previous;
    };
  }, [title]);
}
